import { Routes } from '@angular/router';
import { OtpFormularioComponent } from './pages/otp-formulario/otp-formulario.component';
import { ClaveUnicaLoginComponent } from './pages/claveunica-login/claveunica-login.component';
import { ClaveUnicaCallbackComponent } from './pages/claveunica-callback/claveunica-callback.component';
import { ClaveUnicaLogoutComponent } from './pages/claveunica-logout/claveunica-logout.component';
import { ClaveUnicaErrorComponent } from './pages/claveunica-error/claveunica-error.component';

export const routes: Routes = [
  {
    path: '',
    component: OtpFormularioComponent,
  },
  // Rutas de ClaveÚnica (módulo independiente)
  {
    path: 'claveunica',
    component: ClaveUnicaLoginComponent,
  },
  {
    path: 'claveunica/callback',
    component: ClaveUnicaCallbackComponent,
  },
  {
    path: 'claveunica/logout',
    component: ClaveUnicaLogoutComponent,
  },
  {
    path: 'claveunica/error',
    component: ClaveUnicaErrorComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
